export default class AppTimelinePoint {
    constructor(date, prevDate, type, before, after) {
        this.date = date;
        this.prevDate = prevDate;
        this.type = type;
        this.before = before;
        this.after = after;
        this.show = true;
    }
}